"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WolfRenewalMTADeclineTextOutputWidget = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var WolfMotorMTADeclineText_1 = require("../../declineTextOutputWidget/WolfMotorMTADeclineText");
var react_router_dom_1 = require("react-router-dom");
var WolfRenewalMTADeclineTextOutputWidget = exports.WolfRenewalMTADeclineTextOutputWidget = /** @class */ (function (_super) {
    __extends(WolfRenewalMTADeclineTextOutputWidget, _super);
    function WolfRenewalMTADeclineTextOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.underwritingResultArray = _this.props.engine.getInteraction().underwritingResult;
        _this.inRenewalWindow = _this.props.engine.getInteraction().uistate.renewalWindow;
        _this.referralText = (React.createElement("div", { className: "text-center font-weight-semi-bold mt-3" },
            "Please call our friends at Gallagher on ",
            React.createElement("b", null, "0161 529 1458"),
            " to see if they can help you find the cover you need or visit the British Insurance Brokers\u2019 Association\u00A0",
            React.createElement("a", { className: "font-weight-bold", href: "https://BIBA.org.uk/find-insurance" }, "BIBA.org.uk/find-insurance"),
            " to look for suitable options."));
        _this.renderWording = function (underwritingRule) {
            var declineText = new WolfMotorMTADeclineText_1.WolfMotorMTADeclineText(_this.props);
            var journeyState = _this.props.engine.getJourneyState();
            var mtaHardDecline = journeyState.mtaHardDecline;
            var matchingRules = declineText.underwritingResultCustomerWordings.filter(function (uw) { return uw.key === underwritingRule; });
            if (matchingRules.length) {
                var selectedUw = void 0;
                if (matchingRules.length > 1) {
                    selectedUw = matchingRules.find(function (uw) { return uw.declineType === (mtaHardDecline ? "hard" : "soft"); });
                }
                else {
                    selectedUw = matchingRules[0];
                }
                _this.setState({
                    isHardDecline: selectedUw.declineType === "hard",
                    declineMessage: selectedUw.value,
                    showReferral: selectedUw.showReferral || false,
                });
                _this.props.onStateChange("uistate.isHardDecline", selectedUw.declineType === "hard");
            }
        };
        _this.cancelPolicy = _this.cancelPolicy.bind(_this);
        _this.state = {
            isHardDecline: false,
            declineMessage: "",
            showReferral: false,
        };
        return _this;
    }
    WolfRenewalMTADeclineTextOutputWidget.prototype.componentDidMount = function () {
        this.renderWording(this.underwritingResultArray[0].objectName);
    };
    WolfRenewalMTADeclineTextOutputWidget.prototype.render = function () {
        return (React.createElement("div", { className: "text-group declineTextWidget" },
            React.createElement("div", { className: "panel" },
                React.createElement("h1", { className: "text-center text-blue-1" }, this.state.declineMessage),
                this.inRenewalWindow && this.renderRenewalWindowDeclineText(),
                !this.inRenewalWindow && this.renderRenewalQuoteDeclineText()),
            React.createElement("div", { className: "cancel-policy-btn" },
                React.createElement(React.Fragment, null,
                    this.renderCancelPolicyButton(),
                    !this.state.isHardDecline &&
                        React.createElement(react_router_dom_1.Link, { to: "/dashboard", id: "decline-page-back" },
                            React.createElement("button", { type: "button", role: "link", className: "btn btn-back" }, "Cancel changes"))))));
    };
    WolfRenewalMTADeclineTextOutputWidget.prototype.renderRenewalWindowDeclineText = function () {
        if (this.state.isHardDecline) {
            return (React.createElement("div", { className: "text-center font-weight-light font-weight-400" },
                "In order to make alternative insurance arrangements your car policy will end ",
                (0, commonFunctions_1.getHardDeclineEndDateText)(this.props.interaction),
                " 23:59. Until then you are still covered."));
        }
        else {
            var feeWording = this.chargeCancellationFee(this.props.interaction) ? "" : " without a cancellation fee";
            return (React.createElement("div", { className: "text-center font-weight-semi-bold font-weight-400" },
                "You can cancel these changes which will allow the policy to continue, or if the cover is no longer suitable for your needs you can cancel the insurance",
                feeWording,
                ". Please note this will also cancel your upcoming renewal."));
        }
    };
    WolfRenewalMTADeclineTextOutputWidget.prototype.renderRenewalQuoteDeclineText = function () {
        var baseText = this.state.isHardDecline
            ? (React.createElement("div", { className: "text-center font-weight-light font-weight-400" },
                "You'll need to make alternative insurance arrangements as your car policy will end on ",
                (0, commonFunctions_1.formatDate)(this.props.engine.getInteraction().renewalDetails.lastYearsCoverEndDate, "DD MMMM YYYY"),
                ", 23:59. Until then you are still covered."))
            : (React.createElement("div", { className: "text-center font-weight-semi-bold font-weight-400" },
                "You can cancel these changes which will allow the policy to continue, or if the cover is no longer suitable for your needs you can cancel your renewal",
                this.chargeCancellationFee(this.props.interaction) ? "" : " without a cancellation fee",
                "."));
        return (React.createElement(React.Fragment, null,
            baseText,
            this.state.showReferral && this.referralText));
    };
    WolfRenewalMTADeclineTextOutputWidget.prototype.cancelPolicy = function () {
        this.props.onStateChange("uistate.mtaDeclineAction", "cancelPolicy");
        this.executeEvent("change");
    };
    WolfRenewalMTADeclineTextOutputWidget.prototype.renderCancelPolicyButton = function () {
        if (this.inRenewalWindow) {
            var cancelUrl = this.state.isHardDecline
                ? "/journey/init/product/AnnualMotorInsurance/process/mtcForced/presetPage/".concat(this.props.interaction._id)
                : "/journey/init/product/AnnualMotorInsurance/process/mtc/presetPage/".concat(this.props.interaction._id);
            return (React.createElement(react_router_dom_1.Link, { to: cancelUrl, id: "cancelPolicy" },
                React.createElement("button", { type: "button", className: "btn btn-primary btn-next-arrow-separate btn-next-mobile-margin  btn-next-without-back-button body-navigation-button-margin" }, "Cancel policy")));
        }
        else {
            return (React.createElement("button", { type: "button", onClick: this.cancelPolicy, className: "btn btn-primary btn-next-arrow-separate btn-next-mobile-margin  btn-next-without-back-button body-navigation-button-margin" }, "Cancel policy"));
        }
    };
    WolfRenewalMTADeclineTextOutputWidget.prototype.chargeCancellationFee = function (interaction) {
        if (interaction.underwritingResult && interaction.underwritingResult.length > 0) {
            var limitFailures = interaction.underwritingResult.find(function (uw) { return uw.objectName === "UWW060" || uw.objectName === "UWW061" || uw.objectName === "UWW062" || uw.objectName === "UWW063"; });
            return limitFailures;
        }
        return false;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], WolfRenewalMTADeclineTextOutputWidget.prototype, "journeyRuntimeService", void 0);
    return WolfRenewalMTADeclineTextOutputWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=WolfRenewalMTADeclineOutputTextWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/WolfRenewalMTADeclineOutputTextWidget.js
// module id = 3199
// module chunks = 0